/**
 * Owerride react-bootstrap controls to be context disablable, to work with RolesFilter
 * All components should use this controls
 */
import React from 'react';
import {
  FormControl as BootstrapFormControl,
  Button as BootstrapButton,
  Checkbox as BootstrapCheckbox,
  Radio as BootstrapRadio,
} from 'react-bootstrap';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

export class FormControl extends BootstrapFormControl {
  render() {
    // eslint-disable-next-line
    let { disabled, readonly, ...other } = this.props;
    if (disabled === undefined) disabled = this.context.disabled;
    if (readonly === undefined) readonly = this.context.readonly;
    return <BootstrapFormControl disabled={disabled} readOnly={readonly} {...other} />;
  }
}

FormControl.contextTypes = {
  disabled: React.PropTypes.bool,
  readonly: React.PropTypes.bool,
};

export class Button extends BootstrapButton {
  static defaultProps = {
    block: false,
    active: false,
    disabled: undefined,
  }
  render() {
    // eslint-disable-next-line
    let { disabled, ...other } = this.props;
    if (disabled === undefined) disabled = this.context.disabled;
    return <BootstrapButton disabled={disabled} {...other} />;
  }
}

Button.contextTypes = {
  disabled: React.PropTypes.bool,
};


export class ButtonWithFuncBound extends React.Component {
  static defaultProps = {
    block: false,
    active: false,
    disabled: undefined,
  }
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  shouldComponentUpdate(props) {
    return JSON.stringify(props.args) != JSON.stringify(this.props.args) ||
      props.boundFunc != this.props.boundFunc || this.props.disabled != props.disabled;
  }

  handleClick() {
    this.props.boundFunc(...this.props.args);
  }
  render() {
    // eslint-disable-next-line
    let { disabled, boundFunc, args, ...other } = this.props;
    if (disabled === undefined) disabled = this.context.disabled;
    return <BootstrapButton disabled={disabled} onClick={this.handleClick} {...other} />;
  }
}
ButtonWithFuncBound.propTypes = {
  disabled: React.PropTypes.bool,
  args: React.PropTypes.array,
  boundFunc: React.PropTypes.func.isRequired,
};


export class Checkbox extends BootstrapCheckbox {
  static defaultProps = {
    inline: false,
    disabled: undefined,
  }
  render() {
    // eslint-disable-next-line
    let { disabled, ...other } = this.props;
    if (disabled === undefined) disabled = this.context.disabled;
    return <BootstrapCheckbox disabled={disabled} {...other} />;
  }
}

Checkbox.contextTypes = {
  disabled: React.PropTypes.bool,
};

export class Radio extends BootstrapRadio {
  render() {
    // eslint-disable-next-line
    let { disabled, ...other } = this.props;
    if (disabled === undefined) disabled = this.context.disabled;
    return <BootstrapRadio disabled={disabled} {...other} />;
  }
}

Radio.contextTypes = {
  disabled: React.PropTypes.bool,
};

const dateParseFormats = [
  'DD MMM YYYY',
  'D.M.YYYY',
  'D M YYYY',
];
export class DateTimePicker2 extends DateTimePicker {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = { value: this.props.value || this.props.defaultValue };
  }
  componentWillReceiveProps(props) {
    if (this.props.value != props.value) {
      this.setState({ value: props.value });
    } else if (this.props.defaultValue != props.defaultValue) {
      this.setState({ value: props.defaultValue });
    }
  }
  onChange(val, str) {
    if (this.props.onChange) {
      this.props.onChange(str ? val : undefined, str);
    }
    this.setState({ value: str ? val : undefined, str });
  }
  render() {
    // eslint-disable-next-line
    let { disabled, onChange, defaultValue, value, ...other } = this.props;
    if (disabled === undefined) disabled = this.context.disabled;
    return (<DateTimePicker
      parse={str => (str ? moment(str, dateParseFormats).toDate() : undefined)}
      onChange={this.onChange}
      disabled={disabled} {...other}
      value={this.state.value}
    />);
  }
}

DateTimePicker2.propTypes = {
  disabled: React.PropTypes.bool,
};

DateTimePicker2.contextTypes = {
  disabled: React.PropTypes.bool,
};
